import { gql, TypedDocumentNode } from '@apollo/client'
import { educationDegreeFragment } from './EducationDegreeFragment'
import type { EducationSubjectFragment } from './__generated__/EducationSubjectFragment'

export const educationSubjectFragment: TypedDocumentNode<EducationSubjectFragment> = gql`
  ${educationDegreeFragment}

  fragment EducationSubjectFragment on EducationSubject {
    educationDegree {
      ...EducationDegreeFragment
    }
    id
    name(locale: $locale)
  }
`
